export default (response: any, delay = 1000) =>
  new Promise(resolve => setTimeout(() => resolve(response), delay));
